import { api } from './api';

/* Mirrors Eduvora.Application.Assistant. */

export interface AssistantFact {
  label: string;
  value: string;
}

export interface AssistantRow {
  label: string;
  value: string;
  detail: string | null;
}

export interface TurnView {
  ordinal: number;
  question: string;
  answer: string;
  toolName: string | null;
  facts: AssistantFact[];
  rows: AssistantRow[];
  /** False when the assistant declined — no tool matched, or the role does not permit it. */
  grounded: boolean;
  askedAt: string;
}

export interface ThreadSummary {
  id: string;
  title: string;
  lastMessageAt: string;
  turns: number;
}

export interface ThreadView {
  id: string;
  title: string;
  turns: TurnView[];
}

export interface AssistantAnswer {
  threadId: string;
  title: string;
  turn: TurnView;
  /** False when the prose was templated because AI is off or the call failed.
   *  ⚠ The FIGURES are identical either way — only the wording changes. */
  aiUsed: boolean;
}

export const assistantApi = {
  ask: (question: string, threadId?: string | null) =>
    api.post<AssistantAnswer>('/api/assistant/ask', { threadId: threadId ?? null, question }),

  threads: () => api.get<ThreadSummary[]>('/api/assistant/threads'),

  thread: (id: string) => api.get<ThreadView>(`/api/assistant/threads/${id}`),

  remove: (id: string) => api.del<void>(`/api/assistant/threads/${id}`),

  suggestions: () => api.get<{ suggestions: string[] }>('/api/assistant/suggestions'),
};
